<div class="container modal-update">
    <div class="header">
        <button (click)="navigatePreviousUrl()" class="btn back-button">&larr;</button>
        <h3>GitHub Integration</h3>
    </div>
    <div class="form-content">
        <div class="github-info" *ngIf="isGithubIntegrationExists">
            <div class="user-details">
                <img [src]="githubUserData.avatar_url" alt="GitHub Avatar" class="avatar" />
                <div class="username-info">
                    <div class="username">{{ githubUserData.github_username }}</div>
                    <div *ngIf="githubUserData.github_email" class="email">{{ githubUserData.github_email }}</div>
                </div>
            </div>

            <div class="profile-url">
                <strong>Profile URL:</strong>
                <a [href]="githubUserData.profile_url" target="_blank" class="profile-link">{{
                    githubUserData.profile_url }}</a>
            </div>

            <div class="token-action">
                <button *ngIf="isAccessTokenInvalid" (click)="isRefreshTokenValid ? refreshToken() : authenticate()"
                    class="btn token-button">
                    {{ isRefreshTokenValid ? 'Refresh Token' : 'Authenticate' }}
                </button>
                <button class="btn token-button deltebtn" (click)="deleteIntegration()">
                    Delete Integration
                </button>
            </div>

            <div *ngIf="deleteWarningMessage" class="delete-warning">
                {{ deleteWarningMessage }}
            </div>
        </div>

        <div *ngIf="!isGithubIntegrationExists" class="integrate-button">
            <button (click)="integrateGithub()" class="btn">
                {{ updateFailed ? 'ReIntegrate GitHub' : 'Integrate GitHub' }}
            </button>
            <button *ngIf="updateFailed" (click)="navigateToGithub()" class="btn">
                Go to Existing
            </button>
        </div>
    </div>
</div>